import {RestorableRow} from "../domain/restorable-row.mapper";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * Restores a soft-deleted entity (O2D-PRD-101).
 *
 * The payload is the FLAT `RestorableRow` the trash endpoint delivered — no hydrated `Entity`
 * any more. It used to carry one, for a single reason: `command-send.listener`'s `restore` case
 * derived the republished `entity.changed` payload from `entity.constructor`. It cannot do that
 * now, and does not need to: the listener resolves the class from `mainEntityClass` through the
 * repository register instead (`entity.manager.ts:91-98`), which works for a row that was never
 * an entity in this browser — and, unlike the old way, needs no frontend `Entity` class to exist
 * for every restorable type.
 *
 * The canonical entityType key (snake_case, matching the backend RestoreTypeMap keys, e.g.
 * 'issue', 'issue_status', 'knowledge_object') is carried as `mainEntityClass`, unchanged.
 * `RestoreEntityCommandToDtoTransformer` reads exactly that and `mainEntityUid` to build the
 * backend payload `{entityType, uid}`, so it needed no change at all.
 */
export class RestoreEntityCommand extends AbstractCommand<RestorableRow> {

    public name: CommandName = CommandName.RESTORE_ENTITY;

    public tags = ['entity', 'restore'];

    constructor(row: RestorableRow) {
        super(row.entityType, row.uid, row);
    }

}
